<app-widget-header
  (removeWidget)="removeItem.emit($event)"
  [buttons]="widgetButtons"
  [editMode]="editMode"
  [gridsterItem]="gridsterItem"
  [hideEdit]="false"
  [widgetTitle]="name">
</app-widget-header>

<div *ngIf="cards.length > 0" [style.overflow]="'hidden'" class="gridScrollContainer">
  <dx-scroll-view
    [showScrollbar]="'always'"
    [useNative]="appService.isMediumScreen()"
    [bounceEnabled]="false"
    [direction]="'both'"
    [elementAttr]="{
      class: 'noOverflowContent'
    }">
    <div class="gridContainer">
      <div *ngFor="let card of cards; index as index" [style.position]="'relative'" class="dx-card">

        <app-main-measure-card *ngIf="index === 0" [card]="card"></app-main-measure-card>
        <app-secondary-measure-card *ngIf="index > 0" [card]="card"></app-secondary-measure-card>
        <app-measure-card-form *ngIf="card && card.isWritableOnEdge" [card]="card"></app-measure-card-form>

      </div>
    </div>
  </dx-scroll-view>
</div>

<app-widget-placeholder
  (configurationCallback)="this.openPupup()"
  *ngIf="!gridsterItem.userConfig || !gridsterItem.userConfig.cards || gridsterItem.userConfig.cards.length === 0"
  icon="text_bullet_list_square"></app-widget-placeholder>


<dx-popup
  #popupComponent
  (onShown)="initializePopupForm($event)"
  [(visible)]="popupOpen"
  [dragEnabled]="false"
  [enableBodyScroll]="true"
  [fullScreen]="appService.isSmallScreen()"
  [maxWidth]="'70vw'"
  [wrapperAttr]="{
    class: 'cardFormPopup'
  }"
  [showCloseButton]="true"
  [showTitle]="true"
  title="{{ 'WIDGETS.NAMES.METRIC_CARDS' | translate}}">
  <div #popupContentWrapper class="cardFormBody">
    <div [style.opacity]="!loadingData? 1 : 0" class="flexFill flexColumn">
      <app-partition-selector
        [(selectedPartition)]="dashboardService.selectedPartitionIds[0]">
      </app-partition-selector>
      <app-device-selector
        #deviceSelectorComponent
        [(selectedDeviceId)]="dashboardService.selectedDeviceIds[0]"
        [inputDisplayMode]="'dropdown'"
        [selectedPartitionId]="dashboardService.selectedPartitionIds[0]">
      </app-device-selector>
      <div class="absoluteWrapper">
        <div class="sideBySideLists absoluteFill">
          <app-metric-selector
            (selectedMetricsChange)="updateSelectedMetrics($event)"
            [(selectedMetricIds)]="selectedMetricIds"
            [deviceList]="deviceSelectorComponent.deviceList"
            [disabled]="dashboardService.selectedDeviceIds[0] === undefined || dashboardService.selectedDeviceIds[0] === null"
            [inputDisplayMode]="'table'"
            [selectedDeviceId]="dashboardService.selectedDeviceIds[0]"
            [selectedPartitionId]="dashboardService.selectedPartitionIds[0]"
            [selectionMode]="'all'"
            [style.max-height]="appService.isSmallScreen()? '50vh' : ''"
            [style.width.%]="appService.isSmallScreen()? 100 : 50"
            class="flexFill">
          </app-metric-selector>

          <div [style.width.%]="appService.isSmallScreen()? 100 : 50" class="flexFill flexColumn">

            <dx-text-box
              valueChangeEvent="keyup"
              [(value)]="searchInput"
              [width]="'100%'"
              mode="search">
            </dx-text-box>

            <dx-scroll-view
              direction="both"
              class="previewCardWrapper dx-card flat">
              <dx-sortable
                (onReorder)="reorderItem($event)"
                handle="#movingHandle"
                dragDirection="vertical">

                <ng-container
                  *ngFor="let card of selectedMetrics trackBy trackById; index as index">

                  <div
                    class="flexRow metricCardFormContainers"
                    style="padding: 10px"
                    *ngIf="cardIsSearchedFor(card)">

                    <i class="vr-ic_fluent_re_order_dots_vertical_24_regular movingHandle" id="movingHandle"></i>

                    <div class="formGridContainer">

                      <div class="dx-card" [style.position]="'relative'">

                        <app-main-measure-card *ngIf="index === 0" [card]="card"></app-main-measure-card>
                        <app-secondary-measure-card *ngIf="index > 0" [card]="card"></app-secondary-measure-card>

                      </div>

                      <div style="flex: 1 1; display: flex; flex-direction: column; justify-content: center">
                        <div style="display: flex; gap: 20px; width: 100%">

                          <dx-lookup
                            [(value)]="card.icon"
                            [dataSource]="icons"
                            [fieldTemplate]="'fieldTemplate'"
                            [itemTemplate]="'iconTemplate'"
                            [label]="translate.instant('DASHBOARD.METRIC_CARD.ICON')"
                            [searchEnabled]="false"
                            style="flex: 1 1">
                            <dxo-drop-down-options
                              [hideOnOutsideClick]="true"
                              [showTitle]="false"
                              [toolbarItems]="[]"
                              [width]="250"
                              [height]="'auto'"
                              [wrapperAttr]="{class: 'matrixList'}">
                            </dxo-drop-down-options>
                            <div *dxTemplate="let icon of 'iconTemplate'" style="width: min-content">
                              <i class="vr-ic_fluent_{{icon}}_24_regular iconContainer"
                                 style="font-weight: 300;font-optical-sizing: auto; font-size: 25px;"></i>
                            </div>
                            <div *dxTemplate="let icon of 'fieldTemplate'">
                              <div style="display: flex; flex-direction: row; align-items: center">
                                <i class="vr-ic_fluent_{{icon}}_24_regular"
                                   style="font-weight: 300;font-optical-sizing: auto; height: 30px;"></i>
                                <dx-text-box [disabled]="true" [style.opacity]="0"
                                             style="display:inline-block"></dx-text-box>
                              </div>
                            </div>
                          </dx-lookup>

                          <dx-lookup
                            [(value)]="card.color"
                            [dataSource]="gmService.BASE_COLORS"
                            [fieldTemplate]="'fieldTemplate'"
                            [itemTemplate]="'colorTemplate'"
                            [label]="translate.instant('DASHBOARD.METRIC_CARD.COLOR')"
                            [searchEnabled]="false"
                            style="flex: 1 1">
                            <dxo-drop-down-options
                              [hideOnOutsideClick]="true"
                              [showTitle]="false"
                              [toolbarItems]="[]"
                              [width]="250"
                              [height]="'auto'"
                              [wrapperAttr]="{
                                class: 'matrixList'
                              }">
                            </dxo-drop-down-options>
                            <div *dxTemplate="let color of 'colorTemplate'" style="width: min-content">
                              <div [style.background-color]="color"
                                   style="height: 30px; width: 30px; border-radius: 50%"></div>
                            </div>
                            <div *dxTemplate="let color of 'fieldTemplate'">
                              <div style="display: flex; flex-direction: row; align-items: center">
                                <div [style.background-color]="color"
                                     style="min-height: 30px; min-width: 30px; border-radius: 50%"></div>
                                <dx-text-box [disabled]="true" [style.opacity]="0"
                                             style="display:inline-block"></dx-text-box>
                              </div>
                            </div>
                          </dx-lookup>

                        </div>
                        <div *ngIf="metricIsNumeric(card) && index === 0 && !card.dataTypeGroupShowAsHex" style="display: flex; gap: 20px; width: 100%">
                          <dx-number-box
                            *ngIf="card.minVal !== undefined"
                            (onValueChanged)="card.minVal = !$event.value? 0 : $event.value"
                            [height]="40"
                            [label]="translate.instant('DASHBOARD.METRIC_CARD.MIN')"
                            [max]="card.maxVal"
                            [showSpinButtons]="true"
                            [value]="card.minVal"
                            [width]="'100%'">
                          </dx-number-box>
                          <dx-number-box
                            *ngIf="card.maxVal !== undefined"
                            (onValueChanged)="card.maxVal = !$event.value? 0 : $event.value"
                            [height]="40"
                            [label]="translate.instant('DASHBOARD.METRIC_CARD.MAX')"
                            [min]="card.minVal"
                            [showSpinButtons]="true"
                            [value]="card.maxVal"
                            [width]="'100%'">
                          </dx-number-box>
                        </div>
                      </div>

                    </div>
                    <dx-button
                      (onClick)="deleteCard(index)"
                      [stylingMode]="'text'">
                      <i class="vr-ic_fluent_delete_24_regular"></i>
                    </dx-button>
                  </div>
                </ng-container>
              </dx-sortable>
            </dx-scroll-view>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
    widget="dxButton">
    <dxo-options
      [icon]="'save'"
      [onClick]="saveCard"
      [text]="translate.instant('BUTTONS.SAVE')"
      [type]="'default'"
      stylingMode="contained">
    </dxo-options>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
    widget="dxButton">
    <dxo-options
      [icon]="'close'"
      [onClick]="closeCard"
      [text]="translate.instant('BUTTONS.CANCEL')"
      stylingMode="contained">
    </dxo-options>
  </dxi-toolbar-item>
</dx-popup>
